module.exports = __webpack_public_path__ + "static/sustainability-industry-a0081d064f38ce66f67ed27ed11abcef.jpg";